import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from 'src/app/core/base.component';
import { SessionService } from '../../services/session.service';
import { PaymentMethod } from '@stripe/stripe-js';
import { MatDialogRef } from '@angular/material/dialog';
import { AccountService } from 'src/app/account/account.service';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';

@Component({
    selector: 'stripe-edit-payment-modal',
    templateUrl: './stripe-edit-payment-modal.component.html',
    styleUrl: './stripe-edit-payment-modal.component.scss',
    standalone: false
})
export class StripeEditPaymentModalComponent extends BaseModalComponent implements OnInit {
  public customerId: string;
  public paymentMethodId: string;
  public defaultPaymentMethod: boolean;

  public billingForm: FormGroup = new FormGroup({
    firstName: new FormControl('', {
      validators: Validators.required
    }),
    lastName: new FormControl('', {
      validators: Validators.required
    }),
    city: new FormControl('', {
      validators: Validators.required
    }),
    country: new FormControl('US', {
      validators: Validators.required
    }),
    state: new FormControl('', {
      validators: Validators.required
    }),
    postalCode: new FormControl('', {
      validators: Validators.required
    }),
    address1: new FormControl('', {
      validators: Validators.required
    }),
    address2: new FormControl(),
    email: new FormControl(),
  });

  constructor(sessionService: SessionService,
    public dialogRef: MatDialogRef<StripeEditPaymentModalComponent>,
    private accountService: AccountService) {
    super();
  }

  ngOnInit(): void {

  }

  patchPaymentMethod(paymentMethod) {
    this.billingForm.get('firstName').patchValue(paymentMethod.billingDetails.name.split(' ')[0]);
    this.billingForm.get('lastName').patchValue(paymentMethod.billingDetails.name.split(' ')[1]);
    this.billingForm.get('email').patchValue(paymentMethod.billingDetails.email);
    this.billingForm.get('city').patchValue(paymentMethod.billingDetails.address.city);
    this.billingForm.get('country').patchValue(paymentMethod.billingDetails.address.country);
    this.billingForm.get('postalCode').patchValue(paymentMethod.billingDetails.address.postalCode);
    this.billingForm.get('address1').patchValue(paymentMethod.billingDetails.address.line1);
    this.billingForm.get('address2').patchValue(paymentMethod.billingDetails.address.line2);
    this.billingForm.get('state').patchValue(paymentMethod.billingDetails.address.state);
  }

  updatePayment() {
    this.isLoading = true;
    if (this.billingForm.valid) {
      this.accountService.updateStripeCustomerPaymentMethod(this.paymentMethodId, {
        customerId: this.customerId,
        address1: this.billingForm.get('address1').value,
        address2: this.billingForm.get('address2').value,
        city: this.billingForm.get('city').value,
        state: this.billingForm.get('state').value,
        postalCode: this.billingForm.get('postalCode').value,
        country: this.billingForm.get('country').value,
        name: `${this.billingForm.get('firstName').value} ${this.billingForm.get('lastName').value}`,
        email: this.billingForm.get('email').value,
        isDefault: this.defaultPaymentMethod
      }).subscribe((result: any) => {
        if (result) {
          this.isLoading = false;
          this.dialogRef.close("Save");
        }
      }, err => {
        this.isLoading = false;
        console.log(err);
        // show error message
      });
    }
  }
}
